<template>
    <ScheduledReportForm ref="scheduledReportForm" :is-edit-mode="false" @submit="handleSubmit" />
</template>

<script>
import { mapGetters } from 'vuex';
import ScheduledReportForm from './ScheduledReportForm.vue';

export default {
    name: 'NewScheduledReport',
    components: {
        ScheduledReportForm
    },
    computed: {
        ...mapGetters(['logoPaths']),
    },
    methods: {
        resolveLogoUrl(path) {
            if (!path) return null;
            if (path.startsWith('http://') || path.startsWith('https://')) return path;
            return `${window.location.origin}${path}`;
        },
        handleSubmit(payload) {
            const apiPayload = this.buildApiPayload(payload);
            this.$store.dispatch('reportSchedules/createReportSchedule', apiPayload)
                .then(() => {
                    const message = encodeURIComponent('Scheduled Report successfully created');
                    this.$refs.scheduledReportForm?.prepareForRedirect();
                    window.location.href = `/dashboard/scheduled_report?snackbar=${message}`;
                })
                .catch((error) => {
                    console.error('Failed to create scheduled report:', error);
                });
        },
        buildLogoHtml(headerLogo) {
            if (!headerLogo || headerLogo === 'none') return '';
            const fallbackFastvisa = `${window.location.origin}/assets/logos/logo-fastvisa.png`;
            const fallbackCharter = `${window.location.origin}/assets/logos/logo-charter.png`;
            const resolvedFastvisa = this.resolveLogoUrl(this.logoPaths?.fastvisa) || fallbackFastvisa;
            const resolvedCharter = this.resolveLogoUrl(this.logoPaths?.charter) || fallbackCharter;
            const logoUrl = headerLogo === 'charter' ? resolvedCharter : resolvedFastvisa;
            return `<p style="text-align: center; margin: 0 0 20px;"><img data-scheduled-report-logo="true" src="${logoUrl}" alt="Logo" style="max-width: 280px; max-height: 60px;"></p>`;
        },
        stripLogo(body) {
            if (!body) return '';
            return body.replace(/<p[^>]*>\s*<img[^>]*data-scheduled-report-logo=["']true["'][^>]*>\s*<\/p>/gi, '');
        },
        buildEmailBody(body, headerLogo) {
            const cleanedBody = this.stripLogo(body || '');
            const logoHtml = this.buildLogoHtml(headerLogo);
            return logoHtml ? `${logoHtml}${cleanedBody}` : cleanedBody;
        },
        buildApiPayload(payload) {
            const recipients = (payload?.email_settings?.recipients || [])
                .filter((recipient) => recipient && recipient.id)
                .map((recipient) => ({ recipient_id: recipient.id }));
            const headerLogo = payload?.email_settings?.header_logo || 'fastvisa';
            const bodyWithLogo = this.buildEmailBody(payload?.email_settings?.body || '', headerLogo);

            return {
                report_schedule: {
                    name: payload?.name || '',
                    report_template_id: payload?.template_id || null,
                    status: 'active',// default new item active
                    filter: payload?.filters || {},
                    report_schedule_email_settings_attributes: {
                        subject: payload?.email_settings?.subject || '',
                        body: bodyWithLogo,
                    },
                    report_schedule_recipients_attributes: recipients,
                    report_schedule_schedules_attributes: {
                        frequency: payload?.schedule_type || 'weekly',
                    },
                }
            };
        }
    }
}
</script>
